import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
Vue.use(Vuex)
const state = {
    registerFormFieldDatas: [],
}
const mutations = {
    SET_USER_REGISTRATION(state, data) {
        state.registerFormFieldDatas = data;
    },
    SET_MOVE_FIELD_DATA(state, data) {
        state.registerFormFieldDatas = [];
        var dataSet = {};
        dataSet.requestAccess = data
        state.registerFormFieldDatas = dataSet
    },
    DELETE_FIELD(state, data) {
        var index = state.registerFormFieldDatas.requestAccess.findIndex(element => element.RequestAccessCustomField.id == data);
        if (index != -1) {
            state.registerFormFieldDatas.requestAccess.splice(index, 1);
        }
    },
    DELETE_RULE_DATA(state, data) {
        var index = state.registerFormFieldDatas.requestAccessRules.findIndex(element => element.RequestAccessRule.id == data);
        if (index != -1) {
            state.registerFormFieldDatas.requestAccessRules.splice(index, 1);
        }
    },
    SET_NEW_RULE_DATA(state, data) {
        state.registerFormFieldDatas.requestAccessRules.push(data[0])
    },
    EDIT_NEW_RULE_DATA(state, data) {
        var index = state.registerFormFieldDatas.requestAccessRules.findIndex(element => element.RequestAccessRule.id == data.id);
        if (index != -1) {
            state.registerFormFieldDatas.requestAccessRules.splice(index, 1);
        }
        state.registerFormFieldDatas.requestAccessRules.push(data.data[0])
    }

}
const actions = {
    fetchUserRegisterDatas({
        commit,
        dispatch
    }, authData) {
        Nprogress.start();
        axios.get('/customize_user_request_access/user_registration_list')
            .then(res => {
                Nprogress.done()
                if (res.data.status == "redirect") {
                    router.push("/dashboard");
                  }
                  else{
                commit('SET_USER_REGISTRATION', res.data)
                  }
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.status == 403) {
                        window.location = "/dashboard";
                    }
                }
            })
    },
    fieldMoveUp({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/customize_user_request_access/move_field_up.json', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    fieldMoveDown({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/customize_user_request_access/move_field_down.json', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    // commit("SET_MOVE_FIELD_DATA", response.data.newData);
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteField({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/customize_user_request_access/del_field.json', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    if (response.data.status == 'success') {
                        commit("DELETE_FIELD", postData.fieldId)
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteFieldOption({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/customize_user_request_access/del_option', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    if (response.data.status == 'success') {
                        // commit("SET_MOVE_FIELD_DATA", response.data.newData);
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    addFieldOption({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/customize_user_request_access/add_option', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    if (response.data.status == 'success') {
                        // commit("SET_MOVE_FIELD_DATA", response.data.newData);
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    regexMatch({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/regex_match', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    addNewFieldData({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/customize_user_request_access/add_request_access_custom_field.json', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    if (response.data.status == 'success') {
                        // commit("SET_MOVE_FIELD_DATA", response.data.newData);
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    addNewRuleData({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/add_edit_rule', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if(response.data.status=='redirect')
                    {
                        router.push("/dashboard");
                    }
                    else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    if (postData.fieldId != '' && response.data.status == 'success') {
                        var dataSet = {
                            data: response.data.newData,
                            id: postData.fieldId
                        }
                        commit("EDIT_NEW_RULE_DATA", dataSet);
                    }
                    if (response.data.status == 'success' && postData.fieldId == '') {
                        commit("SET_NEW_RULE_DATA", response.data.newData);
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    deleteRuleData({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/customize_user_request_access/delete_rule', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if(response.data.status=='redirect')
                    {
                        router.push("/dashboard");
                    }
                    else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    if (response.data.status == 'success') {
                        commit("DELETE_RULE_DATA", postData.fieldId);
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    setUserName({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/customize_user_request_access/set_username.json', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if(response.data.status=='redirect')
                    {
                        router.push("/dashboard");
                    }
                    else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    setPassword({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/customize_user_request_access/set_password.json', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if(response.data.status=='redirect')
                    {
                        router.push("/dashboard");
                    }
                    else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    allowPassword({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/customize_user_request_access/allow_change_password', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    viewAccount({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/customize_user_request_access/show_view_profile_link', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if(response.data.status=='redirect')
                    {
                        router.push("/dashboard");
                    }
                    else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    restrictDevice({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/restrict_device', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    restrictAccess({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/restrict_mobile', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    autoApprove({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/auto_approve.json', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    allowSponsor({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/allow_sponsor', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if(response.data.status=='redirect')
                    {
                        router.push("/dashboard");
                    }
                    else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    allowAddMac({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/allow_mac_add', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if(response.data.status=='redirect')
                    {
                        router.push("/dashboard");
                    }
                    else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    saveMapping({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/auto_approve_mapping', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if(response.data.status=='redirect')
                    {
                        router.push("/dashboard");
                    }
                    else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    saveLabel({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/edit_label', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if(response.data.status=='redirect')
                    {
                        router.push("/dashboard");
                    }
                    else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    saveMandatoryField({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/edit_mandatory', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if(response.data.status=='redirect')
                    {
                        router.push("/dashboard");
                    }
                    else if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    saveOptionEdit({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/edit_options', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
    enableCaptcha({
        commit,
        dispatch
    }, postData) {
        return new Promise((resolve, reject) => {
            //Nprogress.start()
            let loader = Vue.$loading.show({
                canCancel: false,
            });
            axios.post('/captive_portal/enable_captcha', qs.stringify(postData, {
                parseArrays: false
            }))
                .then(response => {
                    loader.hide()
                    if (response.data.status != 'success') {
                        reject(response.data.message);
                        return;
                    }
                    resolve(response.data);
                })
                .catch(error => console.log(error));
        });
    },
}
const getters = {
    registerDataGetters: state => {
        return state.registerFormFieldDatas;
    }

}
export default {
    state,
    mutations,
    actions,
    getters
}

